<!-- Loading bar -->
<spri-loading-bar />

<!-- Navigation -->
<spri-vertical-navigation
  class="bg-card dark:bg-gray-900 print:hidden"
  [appearance]="'thin'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.compact"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container spriVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex h-20 items-center justify-center">
      <img
        alt="Logo image"
        class="w-8"
        height="32"
        width="32"
        [ngSrc]="tenantContextService.logoUrl() || 'images/logo/logo.png'"
      />
    </div>
  </ng-container>
</spri-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden"
  >
    <!-- Navigation toggle button -->
    <button class="mr-2" mat-icon-button type="button" (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
    </button>
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <spri-fullscreen class="hidden md:block" />
      <spri-search [appearance]="'bar'" />
      <spri-shortcuts />
      <spri-notifications />
      <spri-user />
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    @if (true) {
      <router-outlet />
    }
  </div>

  <!-- Footer -->
  <div
    class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 md:px-6 dark:bg-transparent print:hidden"
  >
    <span class="text-secondary font-medium"
      >{{ tenantContextService.tenantTitle() }} &copy; {{ tenantContextService.currentYear }}</span
    >
  </div>
</div>
